import rootConfig from "./request";
import users from "drupal-vuejs/src/App/users/user.js";
export default {
  ...users,
  ...rootConfig,
};
